import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { WsAdminIdDisplayPipe } from './ws-admin-id-display.pipe';
import { WsAdminTooltipDirective } from './ws-admin-tooltip.directive';
import { WsTooltipPanelComponent } from './ws-tooltip-panel.component';
import { WsTooltipDirective } from './ws-tooltip.directive';
import { WsTooltipService } from './ws-tooltip.service';
import { WsTooltipRootComponent } from './ws-tooltip-root.component';

@NgModule({
  imports: [
    CommonModule,
    ClipboardModule,
    OverlayModule,
    PortalModule,
  ],
  declarations: [
    WsTooltipPanelComponent,
    WsTooltipDirective,
    WsAdminTooltipDirective,
    WsAdminIdDisplayPipe,
    WsTooltipRootComponent,
  ],
  exports: [
    WsTooltipDirective,
    WsAdminTooltipDirective,
    WsAdminIdDisplayPipe,
    WsTooltipRootComponent,
  ],
  entryComponents: [WsTooltipPanelComponent],
})
export class WsTooltipModule {}
